export default __webpack_public_path__ + "static/media/logo.eb2d310d.png";